import {apiClient} from "@/lib/api/client"
import type {OtkPrintProfile, OtkPrintProfileInput} from "shared"

export async function loadPrintProfiles(): Promise<OtkPrintProfile[]> {
  const { data } = await apiClient.get<OtkPrintProfile[]>(
    "/otk/print-profiles"
  )
  return data.filter(
    (profile) => profile.documentType !== "ELECTRONIC_DOCUMENT"
  )
}

export async function savePrintProfile(
  profile: OtkPrintProfileInput,
  id?: string
): Promise<OtkPrintProfile> {
  const path = id
    ? `/otk/print-profiles/${id}`
    : "/otk/print-profiles"
  const { data } = await apiClient.post<OtkPrintProfile>(
    path,
    profile
  )
  return data
}

export async function deletePrintProfile(profileId: string): Promise<void> {
  await apiClient.delete(`/otk/print-profiles/${profileId}`)
}
